// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".event-detail-info-add-to-calendar__status-icon[data-v-3ecbc7d8]{font-size:21px}.event-detail-info-add-to-calendar__action-icon[data-v-3ecbc7d8]{cursor:pointer}.event-detail-info-add-to-calendar__action-icon__icon[data-v-3ecbc7d8]{font-size:45px}\n", ""]);
// Exports
module.exports = exports;
